<div class="container background-image" style='background-image: url("assets/images/login_fundo.png")'>
	<div></div>
	<div class="content">
		<app-card-login></app-card-login>
	</div>
	<div></div>
</div>